import { render, staticRenderFns } from "./CreateOrderLocation.vue?vue&type=template&id=e06bfa56&scoped=true"
import script from "./CreateOrderLocation.vue?vue&type=script&lang=js"
export * from "./CreateOrderLocation.vue?vue&type=script&lang=js"
import style0 from "./CreateOrderLocation.vue?vue&type=style&index=0&id=e06bfa56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06bfa56",
  null
  
)

export default component.exports